const axios = require('axios').default;

const instance = axios.create({
    baseURL: 'https://api.smsmart.net/sm-hk-admin'
});

instance.interceptors.response.use(function (response) {
    const data = response.data
    if (data.code === 401) {
        return Promise.reject(data);
    }
    return data
}, function (error) {
    return Promise.reject(error);
});

/**
 * 实时预览
 * @param token 用户token
 * @param cameraId 摄像头id
 * @returns {Promise<AxiosResponse<any>>}
 */
export function preview(token, cameraId) {
    return instance.get("/camera/preview", {
        params: {
            id: cameraId
        },
        headers: {
            'Authorization': 'Bearer ' + token
        },
    })
}

/**
 * 云台控制
 * @param token 用户token
 * @param cameraId 摄像头id
 * @param cmd 云台命令
 * @returns {Promise<AxiosResponse<any>>}
 */
export function ptzControl(token, cameraId, cmd) {
    return instance.get("/camera/ptz/control", {
        params: {
            id: cameraId,
            cmd: cmd
        },
        headers: {
            'Authorization': 'Bearer ' + token
        },
    })
}
